"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.reducer = exports.actionTypes = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionTypes = {
  clickLogo: 'CLICK_LOGO',
  clickBottomHome: 'CLICK_BOTTOM_HOME',
  clickBottomSearch: 'CLICK_BOTTOM_SEARCH',
  clickCloseModal: 'CLICK_CLOSE_MODAL',
  clickClearSearchbar: 'CLICK_CLEAR_SEARCHBAR',
  typing: 'TYPING',
  submitSearch: 'SUBMIT_SEARCH',
  openDrawer: 'OPEN_DRAWER',
  closeDrawer: 'CLOSE_DRAWER',
  backToSearchResult: 'BACK_TO_SEARCH_RESULT',
  openNavigateMenu: 'OPEN_MENU',
  closeNavigateMenu: 'CLOSE_MENU'
};
exports.actionTypes = actionTypes;
var initialState = {
  initial: true,
  searching: false,
  typing: false,
  final: false,
  fromHome: true,
  bottomButton: 0,
  openDrawer: false,
  inputValue: '',
  openNavigateMenu: false
};
exports.initialState = initialState;
var openModalHash = '#openModal';

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      newInputValue = _ref.newInputValue;

  switch (type) {
    case actionTypes.clickLogo:
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: true,
        searching: false,
        typing: false,
        final: false,
        fromHome: true,
        bottomButton: 0
      });

    case actionTypes.clickBottomHome:
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: true,
        searching: false,
        typing: false,
        final: false,
        fromHome: true,
        bottomButton: 0,
        inputValue: ''
      });

    case actionTypes.clickBottomSearch:
      if (!window.history.state || window.history.state !== '#openModal') {
        window.history.pushState(openModalHash, '', window.location.pathname);
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        initial: false,
        searching: true,
        typing: false,
        final: false,
        bottomButton: 1
      });

    case actionTypes.clickCloseModal:
      return _objectSpread(_objectSpread({}, state), {}, {
        searching: false,
        typing: false
      });

    case actionTypes.clickClearSearchbar:
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: false,
        searching: true,
        typing: false,
        final: false,
        inputValue: ''
      });

    case actionTypes.typing:
      var isTyping = newInputValue !== '';
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: false,
        searching: true,
        typing: isTyping,
        final: false,
        inputValue: newInputValue,
        bottomButton: 1
      });

    case actionTypes.submitSearch:
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: false,
        searching: false,
        typing: false,
        final: true,
        fromHome: false,
        inputValue: newInputValue,
        bottomButton: 1
      });

    case actionTypes.backToSearchResult:
      return _objectSpread(_objectSpread({}, state), {}, {
        initial: false,
        searching: false,
        typing: false,
        final: true,
        fromHome: false
      });

    case actionTypes.openDrawer:
      return _objectSpread(_objectSpread({}, state), {}, {
        openDrawer: true
      });

    case actionTypes.closeDrawer:
      return _objectSpread(_objectSpread({}, state), {}, {
        openDrawer: false
      });

    case actionTypes.openNavigateMenu:
      return _objectSpread(_objectSpread({}, state), {}, {
        openNavigateMenu: true
      });

    case actionTypes.closeNavigateMenu:
      return _objectSpread(_objectSpread({}, state), {}, {
        openNavigateMenu: false
      });

    default:
      return state;
  }
};

exports.reducer = reducer;